import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgRedirect = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 16,
	height: 16,
	fill: "currentColor",
	viewBox: "0 0 16 16",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		d: "M2.5 2.5h4.619v1H3.5v9h9V8.9h1v4.6h-11v-11Zm9.294 1H8.871v-1H13.5v4.62h-1V4.21L8.686 8.03l-.708-.706L11.794 3.5Z",
		clipRule: "evenodd"
	})
});
export default SvgRedirect;
